import { useEffect, useContext } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

export function usePrompt(when, onConfirm) {
    const { navigator } = useContext(NavigationContext);

    useEffect(() => {
        if (!when) return;

        // Backup original methods
        const originalPush = navigator.push;
        const originalReplace = navigator.replace;
        const originalBlock = navigator.block;

        // Patch push and replace to intercept navigation
        navigator.push = (...args) => {
            onConfirm(
                {
                    action: 'PUSH',
                    location: args[0],
                    retry: () => {
                        navigator.push = originalPush;
                        navigator.replace = originalReplace;
                        navigator.block = originalBlock;
                        navigator.push(...args);
                    },
                },
                () => {
                    navigator.push = originalPush;
                    navigator.replace = originalReplace;
                    navigator.block = originalBlock;
                    navigator.push(...args);
                }
            );
        };

        navigator.replace = (...args) => {
            onConfirm(
                {
                    action: 'REPLACE',
                    location: args[0],
                    retry: () => {
                        navigator.push = originalPush;
                        navigator.replace = originalReplace;
                        navigator.block = originalBlock;
                        navigator.replace(...args);
                    },
                },
                () => {
                    navigator.push = originalPush;
                    navigator.replace = originalReplace;
                    navigator.block = originalBlock;
                    navigator.replace(...args);
                }
            );
        };

        // If navigator.block is available (React Router 6+), use it to catch POP (back/forward)
        if (originalBlock) {
            const unblock = navigator.block((tx) => {
                onConfirm(tx, () => {
                    unblock();
                    tx.retry();
                });
            });

            return () => {
                // cleanup patches & unblock
                navigator.push = originalPush;
                navigator.replace = originalReplace;
                unblock();
            };
        }

        // If no block method, cleanup pushes only
        return () => {
            navigator.push = originalPush;
            navigator.replace = originalReplace;
        };
    }, [when, onConfirm, navigator]);
}
